import { createAction } from '@reduxjs/toolkit';

export const setSortBy = createAction('projectBank/setSortBy');

export const closeProjectBank = createAction('projectBank/closeProjectBank');

export const setSelectedTilaajavastuuBusinessId = createAction(
  'projectBank/setSelectedTilaajavastuuBusinessId'
);

export const openProjectTilaajavastuuFolder = createAction(
  'project-bank/openProjectTilaajavastuuFolder'
);

export const openProjectTreeFolders = createAction(
  'project-bank/openProjectTreeFolders'
);

export const openPrivateProjectBankTreeFolders = createAction(
  'project-bank/openPrivateProjectBankTreeFolders'
);

export const closeProjectTreeFolders = createAction(
  'project-bank/closeProjectTreeFolders'
);

export const closePrivateProjectBankTreeFolders = createAction(
  'project-bank/closePrivateProjectBankTreeFolders'
);

export const openPdfPreviewDialog = createAction(
  'project-bank/openPdfPreviewDialog'
);

export const closePdfPreviewDialog = createAction(
  'project-bank/closePdfPreviewDialog'
);

export const setProjectBankViewMode = createAction(
  'project-bank/setProjectBankViewMode'
);

export const toggleSelectProjectBankFile = createAction(
  'project-bank/toggleSelectProjectBankFile'
);

export const clearSelectedProjectBankFiles = createAction(
  'project-bank/clearSelectedProjectBankFiles'
);

export const setIsProjectBankFileSelectDialogOpen = createAction(
  'project-bank/setIsProjectBankFileSelectDialogOpen'
);

// Closing the file selector dialog resets this whole slice (see the slice):
// right for a selector opened over some other scene, wrong for one opened
// over the project bank itself. A dialog that opens the selector over the
// bank takes a snapshot of the slice first and puts it back with this once
// the selector has closed (ProjectEmailDialog).
export const restoreProjectBankState = createAction(
  'project-bank/restoreProjectBankState'
);

export const openTransferFolderStructureDialog = createAction(
  'projectBank/openTransferFolderStructureDialog'
);

export const closeTransferFolderStructureDialog = createAction(
  'projectBank/closeTransferFolderStructureDialog'
);
export const setUpdateItemsInState = createAction(
  'projectBank/setUpdateItemsInState'
);

export const setSelectedPrivateProjectBankFolderId = createAction(
  'projectBank/setSelectedPrivateProjectBankFolderId'
);

export const setSelectedProjectBankVisibilityMode = createAction(
  'projectBank/setSelectedProjectBankVisibilityMode'
);

export const setSelectedProjectBankDataTransferTargetVisibilityMode =
  createAction(
    'projectBank/setSelectedProjectBankDataTransferTargetVisibilityMode'
  );

export const setIsAddFolderDialogOpen = createAction(
  'projectBank/setIsAddFolderDialogOpen'
);

export const selectPrivateProjectBankItem = createAction(
  'projectBank/selectPrivateProjectBankItem'
);

export const setSelectedPrivateProjectBankItems = createAction(
  'projectBank/setSelectedPrivateProjectBankItems'
);

export const clearSelectedPrivateProjectBankItems = createAction(
  'projectBank/clearSelectedPrivateProjectBankItems'
);
